export default () => ({
    textTitle: 'Madec',
    url:'https://server.madec.com.mx/',
    x:5

})